import { format } from 'date-fns';
import { PartnersTableDictionary } from 'types/i18n';
import { UnreachableError } from 'utils/errors';

export const partnersTableDictionaryRu: PartnersTableDictionary = {
  idColumnLabel: 'id',
  fullNameColumnLabel: 'Полное имя',
  emailColumnLabel: 'Email',
  phoneColumnLabel: 'Телефон',
  statusColumnLabel: 'Статус',
  clientsCountColumnLabel: 'Клиенты',
  earnedAmountColumnLabel: 'Заработано',
  paidAmountColumnLabel: 'Выплачено',
  balanceColumnLabel: 'Баланс',
  latestUpdateDateColumnLabel: 'Update',

  statusText(status) {
    switch (status) {
      case 'ACTIVE':
        return 'Активный';
      case 'DISABLED':
        return 'Заблокирован';
      case 'CANDIDATE':
        return 'Регистрация';
      default:
        throw new UnreachableError(status);
    }
  },
  latestUpdateDateText(date) {
    if (date) {
      return format(new Date(date), 'dd.MM.yyyy');
    }

    return '-';
  },
};
